import { cn } from '@/lib/utils'

export function CoverFlowSkeleton() {
  return (
    <div className="flex items-center justify-center py-4">
      <div className="flex w-[700px] items-end justify-center">
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            className={cn(
              'animate-pulse rounded-lg',
              index === 1 ? 'h-[300px] w-[276px]' : 'h-[265px] w-[244px]',
              index === 1 ? '' : '-mx-4 md:-mx-5',
              index !== 1 && 'mb-5 opacity-70',
            )}
            style={{
              background: 'var(--home-card-placeholder-gradient)',
              boxShadow: 'var(--home-card-shadow)',
            }}
          />
        ))}
      </div>
    </div>
  )
}
